export default [
  {
    "name-uz": "To'lanmagan",
    "name-ru": "To'lanmagan",
    "name-en": "To'lanmagan",
    id: "NOT_PAID",
  },
  {
    "name-uz": "Qisman To'langan",
    "name-ru": "Qisman To'langan",
    "name-en": "Qisman To'langan",
    id: "HALF_PAID",
  },
  {
    "name-uz": "To'liq to'langan",
    "name-ru": "To'liq to'langan",
    "name-en": "To'liq to'langan",
    id: "PAID",
  },
  // A refund (negative payment) moves a 2026 contract into its own PaidStatus.REFUNDED
  // bucket. Without an entry here the status banner on the contract-show page resolved
  // to an empty name and a null colour, i.e. white text on white - the banner looked
  // like it was missing entirely.
  {
    "name-uz": "To'lov qaytarilgan",
    "name-ru": "To'lov qaytarilgan",
    "name-en": "To'lov qaytarilgan",
    id: "REFUNDED",
  },
];
